export enum LayoutActionTypes {
    START_REQUEST = 'LAYOUT_START_REQUEST',
    END_REQUEST = 'LAYOUT_END_REQUEST',
    GET_LAYOUT_SUCCESS = 'GET_LAYOUT_SUCCESS',
    GET_LAYOUT_ERROR = 'GET_LAYOUT_ERROR'
}
